import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@skudo/services/user.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const noUserGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const userService = inject(UserService);

  const user = userService.getCurrentUser().getValue();
  if (!user) {
    return true;
  } else {
    return userService.verify(user).pipe(
      catchError(() => of(true)),
      map(() => {
        router.navigateByUrl('/').catch(console.error);
        return false;
      })
    );
  }
};
